module.exports = __webpack_public_path__ + "img/logo.12be109f.png";